import 'Agent/Accounts/components/AccountImagesCard.sass';
import {AccountImage} from 'Agent/Accounts/ducks/accountDetail';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {Table, TableCell, TableRow, TableBody} from '@material-ui/core';
import AllstateCard from 'Shared/components/AllstateCard';
import FileDownloadButton, {FileExtension} from 'Shared/components/FileDownloadButton';
import {renderAsyncView} from 'Shared/components/RenderAsync';
import {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {AgentAgencyClaim} from 'Users/models/AgentAgencyClaim';

const NoResultsAvailableMessage = () => (
  <div className="account-images__no-results-available">No Results Available</div>
);

type ImagesTableProps = {images: AccountImage[]};
const ImagesTable = ({images, selectedAgency}: ImagesTableProps & WithSelectedAgencyProps) => (
  <Table className="account-images__table">
    <TableBody>
      <TableRow>
        <TableCell>File Name</TableCell>
        <TableCell>Date Created</TableCell>
        <TableCell>Links</TableCell>
      </TableRow>
      {images &&
        images.length > 0 &&
        images.map(image => (
          <TableRow key={`account-image-row_${image.description}`}>
            <TableCell>{image.description}</TableCell>
            <TableCell>{toFormattedDateAsUTC(image.createDate)}</TableCell>
            <TableCell>
              <FileDownloadButton
                downloadedFileName={image.description!}
                extension={FileExtension.PDF}
                displayTooltip={false}
                relativeFileLocation={
                  image.links![0]!.href! +
                  addFilterParameters({encryptedIdentifier: selectedAgency.encryptedIdentifier})
                }
              >
                Download File
              </FileDownloadButton>
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  </Table>
);

const AccountImagesCard = (props: {selectedAgency: AgentAgencyClaim}) => {
  const {accountImages} = useSelector((state: ReducerState) => state.accountDetails);

  return (
    <AllstateCard title="Account Images">
      <div className="account-images__container">
        {renderAsyncView(accountImages, imagesPayload =>
          imagesPayload.images && imagesPayload.images.length > 0 ? (
            <ImagesTable images={imagesPayload.images} selectedAgency={props.selectedAgency} />
          ) : (
            <NoResultsAvailableMessage />
          )
        )}
      </div>
    </AllstateCard>
  );
};

export default AccountImagesCard;
